import { useEffect, useState } from 'react';
import {
    formatFootballPhaseClockLabel,
    isEventPhaseClockTicking,
    resolveFootballPhaseClockMode,
    toFootballMatchClockSeconds,
} from 'src/domains/sportsbook/webview/components/events/row/formatEventPhase';

export const useEventPhaseClockLabel = (
    timeElapsedInPhase: string | null | undefined,
    currentPhase: string | null | undefined,
    sport: string,
    enabled: boolean
): string => {
    const isFootball = enabled && sport === 'football';
    const mode = isFootball ? resolveFootballPhaseClockMode(currentPhase) : null;
    const baseSeconds = isFootball ? toFootballMatchClockSeconds(timeElapsedInPhase, currentPhase) : null;
    const isTicking = isFootball && isEventPhaseClockTicking(currentPhase);
    const [displaySeconds, setDisplaySeconds] = useState<number | null>(baseSeconds);

    useEffect(() => {
        setDisplaySeconds(baseSeconds);
    }, [baseSeconds, timeElapsedInPhase, currentPhase]);

    useEffect(() => {
        if (baseSeconds === null || isTicking === false) {
            return;
        }

        const intervalId = setInterval(() => {
            setDisplaySeconds((prev) => (prev === null ? null : prev + 1));
        }, 1000);

        return () => {
            clearInterval(intervalId);
        };
    }, [baseSeconds, isTicking, timeElapsedInPhase, currentPhase]);

    if (isFootball === false) {
        return '';
    }

    return formatFootballPhaseClockLabel(mode, displaySeconds, currentPhase);
};
